import { render, staticRenderFns } from "./main.formas-pago.vue?vue&type=template&id=11777c64"
import script from "./main.formas-pago.vue?vue&type=script&lang=js"
export * from "./main.formas-pago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports